import { cn } from '@/utils/сn';

interface SectionProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  className?: string;
  isLast?: boolean;
}

export const Section = ({ children, isLast = false, title, description, className }: SectionProps) => {
  return (
    <div
      className={cn(`flex flex-col py-[30px] px-6`, className, {
        'border-b-0': isLast,
        'border-b border-blue-100': !isLast,
      })}
    >
      <div className="flex flex-col gap-[2px]">
        {title && <p className="text-black font-semibold font-inter text-lg leading-normal">{title}</p>}
        {description && <p className="text-body-small text-grey-700">{description}</p>}
      </div>
      {children}
    </div>
  );
};
